import React, {Fragment, useEffect} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {PrimaryButton, SecondaryButton} from 'cstar-react-primitives';
import { cashbotName } from '../core/coreUtils';


export const Dialog = (props) => {

    const primaryRef = React.createRef();
    const secondaryRef = React.createRef();

    useEffect(() => {

        
        if (props.secondaryAction)
            secondaryRef.current.focus();
        else
            primaryRef.current.focus();
    }, []);

    const {
        prompt, 
        primaryText, 
        primaryAction, 
        secondaryText, 
        secondaryAction, 
        cssClass 
    } = props;

    const classes = classNames('dialog', {[cssClass]: cssClass !== undefined});

    return (
        <Fragment>
            <div className={classes} role="dialog" aria-label={prompt}>
                <p className="dialog__prompt">{prompt}</p>
                <div className="dialog__actions">
                    {secondaryAction && (
                        <div className="dialog__secondary-cta">
                            <SecondaryButton
                                isSmall
                                btnText={secondaryText}
                                onClick={secondaryAction}
                                atts={{ref: secondaryRef}}
                                cashbotName={cashbotName}
                            />
                        </div>
                    )}
                    <div className="dialog__primary-cta">
                        <PrimaryButton
                            isSmall
                            btnText={primaryText}
                            onClick={primaryAction}
                            atts={{ref: primaryRef}}
                            cashbotName={cashbotName}
                        />
                    </div>
                </div>
            </div>
            <div className="dialog__backdrop" />
        </Fragment>
    );
}

Dialog.defaultProps = {
    secondaryText: '',
    secondaryAction: null,
    cssClass: undefined
};

Dialog.propTypes = {
    prompt: PropTypes.string.isRequired,
    primaryText: PropTypes.string.isRequired,
    primaryAction: PropTypes.func.isRequired,
    secondaryText: PropTypes.string,
    secondaryAction: PropTypes.func,
    cssClass: PropTypes.string
};

